import { createViewFilesList } from "@/modules/lasalle/submissions/views/ViewFilesList";
import type { TViewFilesListUseCases } from "@/modules/lasalle/submissions/views/ViewFilesList";

// Simple deal info for dropdown
type TDealOption = {
    id: string;
    name: string;
    code: string;
};

/**
 * View parameters (injected dependencies).
 *
 * Extends the shared file-list useCases with extra capabilities that the
 * composition root wires but the list view doesn't consume directly
 * (upload & deals are handled elsewhere).  Kept for backward compatibility.
 */
export type TViewFilesParams = {
    useCases: () => TViewFilesListUseCases & {
        useDeals: () => { data: TDealOption[] | null; loading: boolean };
        onUploadFile: (data: {
            dealId: string;
            period: string;
            fileType: string;
            file: File;
        }) => Promise<void>;
    };
};

/**
 * View props (from router/parent)
 */
export type TViewFilesProps = Record<string, never>;

/**
 * Creates the Files list view component (all file types, no filter).
 */
export const createViewFiles = ({ useCases }: TViewFilesParams) =>
    createViewFilesList({
        title: "Files",
        description: "View and manage your financial files",
        errorTitle: "Failed to load files",
        emptyTitle: "No files yet",
        emptyDescription: "Upload your first financial file to get started.",
    })({ useCases });
